// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/plyr/dist/plyr.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plyr__video-wrapper {
    z-index: 0;
}

.plyr__poster {
    background-size: cover;
}

.plyr--youtube .plyr__poster {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/plyr/custom.css"],"names":[],"mappings":"AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB","sourcesContent":["@import \"~plyr/dist/plyr.css\";\r\n\r\n.plyr__video-wrapper {\r\n    z-index: 0;\r\n}\r\n\r\n.plyr__poster {\r\n    background-size: cover;\r\n}\r\n\r\n.plyr--youtube .plyr__poster {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
